import React from 'react';
import AdminReservations from '../../admin/pages/AdminReservations';

export default function PosReservations() {
  return <AdminReservations />;
}
